var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 6.44772 0.447715 6 1 6H11C11.5523 6 12 6.44772 12 7V11C12 11.5523 11.5523 12 11 12H1C0.447715 12 0 11.5523 0 11V7Z",
    fill: "#8A8EB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 2.44772 0.447715 2 1 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H1C0.447715 4 0 3.55228 0 3Z",
    fill: "#8A8EB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C2 0.223858 2.22386 0 2.5 0C2.77614 0 3 0.223858 3 0.5V2H2V0.5Z",
    fill: "#8A8EB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C9 0.223858 9.22386 0 9.5 0C9.77614 0 10 0.223858 10 0.5V2H9V0.5Z",
    fill: "#8A8EB2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.e81ba655981f3afac3fa103d36ce294a.svg";
export { ForwardRef as ReactComponent };